<template>
  <div>
    <PageTitle
      title="Product View"
      :backBtn="true"
      :editRoute="'/product/edit/' + Product.id"
      :permission="'Product Edit'"
    />
    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col v-col cols="12" sm="12" md="12" lg="9">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title producttiltle"
              ><v-icon color="blue" small>mdi-layers-triple-outline</v-icon
              ><span class="ml-3"> Product Details</span></v-card-title
            >

            <v-container fluid class="light gray lighten-12 productdetailscard">
              <ValidationObserver ref="observer">
                <v-row>
                  <template v-if="messages">
                    <v-alert
                      v-for="msg in messages"
                      :key="msg"
                      class="messages"
                      dense
                      type="error"
                      >{{ msg }}
                    </v-alert>
                  </template>
                </v-row>
                <v-row class="category-detail">
                  <v-col cols="12" lg="6" class="py-0">
                    <v-col
                      cols="12"
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      class="py-0"
                    >
                      <v-row>
                        <v-col cols="4" sm="12" md="4" lg="4" class="pt-4 pl-0">
                          <v-dialog
                            v-model="dialog"
                            max-width="50%"
                            @keydown.esc="cancel"
                          >
                            <v-card>
                              <v-img :src="pic" alt="" />
                            </v-card>
                          </v-dialog>
                          <v-hover v-slot="{ hover }">
                            <div
                              :elevation="hover ? 12 : 2"
                              :class="{ cards: hover }"
                            >
                              <v-img
                                v-if="Product.image"
                                height="100"
                                width="100"
                                :src="Product.image"
                                @mouseover="openImage(Product.image)"
                              >
                                <v-icon
                                  class="pl-10 pt-8 text-center"
                                  :class="{ 'show-btns': hover }"
                                  color="white"
                                >
                                  mdi-eye
                                </v-icon>
                              </v-img>
                              <v-img
                                v-else
                                src="../../../assets/noimageavailable.png"
                                height="100"
                                width="100"
                                class="rounded"
                              >
                              </v-img>
                            </div>
                          </v-hover>
                        </v-col>

                        <v-col cols="8" sm="12" md="8" lg="8" class="pt-4 pr-0">
                          <v-row class="pt-1 pr-0 productname">
                            {{ Product.name }}
                          </v-row>
                          <v-row class="pt-1 pr-0">
                            <v-chip
                              style="
                                color: white;
                                font-variant-caps: all-small-caps;
                                font-weight: bold;
                              "
                              text-color="white"
                              :color="getStatusColor(this.Product.is_active)"
                              dark
                              label
                              >{{
                                this.Product.is_active ? 'Active' : 'Archived'
                              }}</v-chip
                            >
                          </v-row>
                          <v-row class="pt-1 pl-3 pr-0">
                            <v-row>
                              <div
                                id="qr-code"
                                v-print="printQr"
                                class="qr-button"
                              >
                                <VueQrcode
                                  :value="getQrData(Product)"
                                  :options="{ width: 50, Type: Product }"
                                />
                              </div>
                              <div
                                class="pt-4 pr-0"
                                style="
                                  color: blue;
                                  background-color: transparent;
                                  text-decoration: none;
                                  font-weight: bold;
                                "
                              >
                                {{ Product.code }}
                              </div>
                            </v-row>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6" class="pt-0">
                    <v-col
                      cols="12"
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      class="py-0"
                    >
                      <v-row>
                        <v-col cols="6" sm="12" md="6" lg="6" class="pt-1 pl-0">
                          <span class="subtextlable">Reference Number</span>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                          lg="6"
                          class="pt-3 pl-0 statustext"
                        >
                          ({{ Product.reference_number }})</v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col cols="6" sm="12" md="6" lg="6" class="pt-1 pl-0">
                          <span class="subtextlable">Category</span>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                          lg="6"
                          class="pt-1 pl-0 viewDetails"
                        >
                          {{
                            Product.category ? Product.category.name : '----'
                          }}</v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col cols="6" sm="12" md="6" lg="6" class="pt-1 pl-0">
                          <span class="subtextlable">Brand</span>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                          lg="6"
                          class="pt-1 pl-0 viewDetails"
                        >
                          {{ Product.brand.name }}</v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col cols="6" sm="12" md="6" lg="6" class="pt-1 pl-0">
                          <span class="subtextlable">Min Price</span>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                          lg="6"
                          class="pt-1 pl-0 viewDetails"
                        >
                          LKR
                          {{ Product.min_price | formatCurrency }}</v-col
                        >
                      </v-row>
                    </v-col>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="3">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title producttiltle"
              ><v-icon color="blue" small>mdi-yeast</v-icon
              ><span class="ml-3"> Units</span>
            </v-card-title>

            <v-container fluid class="light gray lighten-12 productdetailscard">
              <ValidationObserver ref="observer">
                <v-row class="category-detail" align="left">
                  <v-col>
                    <div>
                      <v-container
                        fluid
                        class="light gray lighten-12 px-0 py-0"
                      >
                        <v-expansion-panels>
                          <v-expansion-panel
                            v-for="unit in Product.units"
                            :key="unit.index"
                          >
                            <v-expansion-panel-header
                              class="px-5 py-5 d-flex justify-start"
                              color="white"
                              :expand-icon="
                                Product.defaultUnit.id == unit.id
                                  ? 'n'
                                  : 'mdi-menu-down'
                              "
                            >
                              <v-row>
                                <v-col cols="6" sm="6" md="12" lg="6">
                                  <span class="subtextlable">
                                    {{ unit.name }}
                                    {{
                                      Product.defaultUnit.id == unit.id
                                        ? '( Default unit )'
                                        : ''
                                    }}
                                  </span> </v-col
                                ><v-col cols="6" sm="6" md="12" lg="6">
                                  <span
                                    class="subtextlable"
                                    :class="
                                      unit.product_units.is_purchasing_unit ==
                                      true
                                        ? 'purchasing-unit'
                                        : 'selling-unit'
                                    "
                                  >
                                    {{
                                      unit.product_units.is_purchasing_unit ==
                                      true
                                        ? 'Purchasing and selling  unit'
                                        : 'Selling  unit'
                                    }}</span
                                  ></v-col
                                >
                              </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content
                              v-if="Product.defaultUnit.id != unit.id"
                              class="px-5 pb-4"
                            >
                              <v-row class="theme">
                                <v-col cols="12" sm="12" md="3" lg="4"
                                  ><span class="subtextlable">{{
                                    unit.name
                                  }}</span></v-col
                                >
                                <v-col cols="12" sm="12" md="3" lg="4">
                                  {{
                                    unit.product_units.conversionOperator.symbol
                                  }}
                                  {{ unit.product_units.conversion_value }}
                                  equal to</v-col
                                >
                                <v-col cols="12" sm="12" md="3" lg="4"
                                  ><span class="subtextlable">{{
                                    Product.defaultUnit.name
                                  }}</span></v-col
                                >
                              </v-row>
                              <v-divider></v-divider>
                              <v-row class="theme">
                                <v-col cols="12" sm="12" md="3" lg="4">
                                  <span class="subtextlable">{{
                                    Product.defaultUnit.name
                                  }}</span></v-col
                                >
                                <v-col cols="12" sm="12" md="3" lg="4">
                                  {{
                                    unit.product_units.reverseConversionOperator
                                      .symbol
                                  }}
                                  {{
                                    unit.product_units.reverse_conversion_value
                                  }}
                                  equal to</v-col
                                >
                                <v-col cols="12" sm="12" md="3" lg="4">
                                  <span class="subtextlable">
                                    {{ unit.name }}
                                  </span>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-container>
                    </div>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-container>
          </v-card>
        </v-col>

        <v-col cols="4" v-if="false">
          <v-card class="lighten-12 card-content" height="100%">
            <v-card-title>QR Code</v-card-title>
            <v-container
              fluid
              class="light gray lighten-12 px-0 py-0 d-flex justify-center"
            >
              <v-row height="100%">
                <v-col cols="12" align="center" height="100%">
                  <div id="qr-code">
                    <VueQrcode
                      :value="getQrData(Product)"
                      :options="{ width: 100, Type: Product }"
                    />
                  </div>
                  <div class="qr-overlay"></div>
                  <v-btn v-print="printQr" class="qr-button"
                    >Print</v-btn
                  ></v-col
                >
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="false">
        <v-col cols="12">
          <v-card class="lighten-12 card-content">
            <v-card-title>Units</v-card-title>
            <v-container fluid class="light gray lighten-12 px-0 py-0">
              <v-expansion-panels>
                <v-expansion-panel
                  v-for="unit in Product.units"
                  :key="unit.index"
                >
                  <v-expansion-panel-header
                    class="px-5 d-flex justify-start"
                    color="white"
                  >
                    <strong class="mx-2"> {{ unit.name }}</strong>
                    {{
                      Product.defaultUnit.id == unit.id
                        ? '( Default unit )'
                        : ''
                    }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                    v-if="Product.defaultUnit.id != unit.id"
                  >
                    <v-row>
                      1 <strong class="mx-2">{{ unit.name }}</strong>
                      {{ unit.conversionOperator }}
                      {{ unit.conversionValue }} equal to 1
                      <strong class="mx-2">{{
                        Product.defaultUnit.name
                      }}</strong>
                    </v-row>
                    <v-row>
                      1
                      <strong class="mx-2">{{
                        Product.defaultUnit.name
                      }}</strong>
                      {{ unit.reverseConversionOperator }}
                      {{ unit.reverseConversionValue }} equal to 1
                      <strong class="mx-2">{{ unit.name }}</strong>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" lg="12">
          <v-card>
            <v-card-title class="v-card__title producttiltle"
              ><v-icon color="blue" small>mdi-bulletin-board</v-icon
              ><span class="ml-3"> Product Related Factors</span>
            </v-card-title>

            <v-container fluid class="light gray lighten-12 productdetailscard">
              <v-tabs v-model="tab" background-color="primary" dark>
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="item in items" :key="item.tab">
                  <v-icon small v-if="item.tab == 'Batch'"
                    >mdi-checkbook</v-icon
                  >
                  <!-- <v-icon small v-if="item.tab == 'Supplier'"
                  >mdi-account-multiple-outline</v-icon
                > -->
                  <v-icon small v-if="item.tab == 'Purchase'"
                    >mdi-truck-check-outline</v-icon
                  >
                  <v-icon small v-if="item.tab == 'Purchase Order'"
                    >mdi-storefront-outline</v-icon
                  >
                  <v-icon small v-if="item.tab == 'Purchase Return'"
                    >mdi-truck-delivery-outline</v-icon
                  >
                  <v-icon small v-if="item.tab == 'Sales'"
                    >mdi-sack-percent</v-icon
                  >
                  <v-icon small v-if="item.tab == 'Shop & Supplier'"
                    >mdi-shopping</v-icon
                  >
                  {{ item.tab }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in items" :key="item.tab">
                  <ProductBatchComponent
                    :module="'products'"
                    :id="Product.id"
                    v-if="item.tab === 'Batch'"
                  />

                  <!-- <ProductSupplier
                  :module="'products'"
                  :id="Product.id"
                  v-if="item.tab == 'Supplier'"
                /> -->
                  <PurchaseList
                    v-if="item.tab === 'Purchase'"
                    :module="'products'"
                    :id="Product.id"
                  >
                  </PurchaseList>
                  <purchase-order-list
                    v-if="item.tab === 'Purchase Order'"
                    :module="'products'"
                    :id="Product.id"
                  ></purchase-order-list>
                  <PurchaseReturnList
                    v-if="item.tab === 'Purchase Return'"
                    :module="'products'"
                    :id="Product.id"
                  ></PurchaseReturnList>
                  <ProductSale
                    v-if="item.tab === 'Sales'"
                    :module="'products'"
                    :id="Product.id"
                  >
                  </ProductSale>
                  <ProductShop
                    v-if="item.tab === 'Shop & Supplier'"
                    :module="'products'"
                    :id="Product.id"
                  >
                  </ProductShop>
                </v-tab-item>
              </v-tabs-items>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <BatchForm
        ref="batchForm"
        @conform="refreshBatches($event)"
        :visible="showScheduleForm"
        :productUnits="productUnits"
        :productbatch="productBatch"
        :product="productDetails"
      />
    </v-container>
  </div>
</template>
<script>
import { required, email, max } from 'vee-validate/dist/rules';
import paginationComponent from '../../shared/components/pagination.vue';
import { Product } from '../../../models/Product';
import { ProductEntity } from '../../../models/EntityModels/ProductEntity';
import ProductBatchComponent from './ProductBatchComponent';
import BatchView from './ProductBatchView';
import BatchForm from './ProductBatchModal';
import ProductShop from './ProductShop.vue';
import { ProductBatch } from '../../../models/ProductBatch';
import { ProductViewModel } from '../../../models/View Models/ProductViewModel';
import { SupplierListViewModel } from '@/models/View Models/Supplier';
import _ from 'lodash';
import moment from 'moment';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
// import the component
import Treeselect from '@riophae/vue-treeselect';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PurchaseOrderList from './ProductPurchaseOrderList.vue';
import PurchaseList from './ProductPurchaseList.vue';
import PurchaseReturnList from './ProductPurchaseReturnList.vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import ProductBatchViewModal from '@/modules/Product/components/ProductBatchView';
import ProductSupplier from './ProductSupplierComponent';
import ProductSale from './ProductSaleList';
setInteractionMode('eager');
extend('required', {
  ...required,
  message: '{_field_} is required',
});
extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});
extend('email', {
  ...email,
  message: 'Email must be valid',
});
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ProductBatchComponent,
    BatchForm,
    Treeselect,
    BatchView,
    paginationComponent,
    PurchaseOrderList,
    PurchaseList,
    PurchaseReturnList,
    VueQrcode,
    ProductSupplier,
    ProductSale,
    ProductShop,
  },
  data: () => ({
    tabunit: '',
    itemsunit: [
      { tab: 'Unit', content: 'this is credit tab' },
      { tab: 'Recent Logs', content: 'this is credit tab' },
    ],
    purchaseTab: new PurchaseTabViewModel(),
    searchPurchaseTabSuppliers: null,
    searchSuppliers: null,
    purchaseOrderTab: new PurchaseOrderTabViewModel(),
    purchaseReturnTab: new PurchaseReturnTabViewModel(),
    productDetails: [],
    selectedSuppliers: [],
    productUnits: [],
    items: [
      { tab: 'Shop & Supplier', content: '' },
      // { tab: "Supplier", content: "" },
      { tab: 'Batch', content: 'this is credit tab' },

      { tab: 'Purchase', content: '' },
      { tab: 'Purchase Order', content: '' },
      { tab: 'Purchase Return', content: '' },
      { tab: 'Sales', content: '' },
    ],
    tab: 'Credit',
    Product: new Product(),
    errors: [],
    messages: [],
    showScheduleForm: false,
    supplierHeaders: [
      { text: 'Reference No', value: 'reference_number', width: '33%' },
      { text: 'Name', value: 'name', width: '33%' },
      { text: 'Email Address', value: 'phone' },
      { text: 'Phone', value: 'email' },
      { text: '', value: 'action', width: '33%' },
    ],
    filter: {
      search: '',
      reference_number: '',
      start: '',
      end: '',
      status: '',
    },
    ProductBatches: [],
    ProductSuppliers: [],
    ProductPurchase: [],
    ProductPurchaseOrder: [],
    ProductPurchaseReturn: [],
    productBatch: new ProductBatch(),
    pic: '',
    dialog: false,
  }),
  created() {
    this.GetProductDetails();
    this.GetSuppliers();
  },
  computed: {
    printQr() {
      return {
        id: 'qr-code',
        popTitle: this.Product.name,
      };
    },
  },
  methods: {
    getQrData(product) {
      var data = {
        id: product.id,
        Reference_Number: product.reference_number,
        Name: Product.name,
        Code: Product.code,
      };
      return JSON.stringify(data);
    },
    print() {
      this.$htmlToPaper('qr-code');
    },
    refreshData() {
      if (this.$refs.pagination) {
        this.$refs.pagination.forEach((item) => {
          item.refreshData();
        });
      }
    },
    // Batch Data Received from pagination component emit function
    receiveBatchResponse(batchData) {
      this.ProductBatches = batchData;
    },
    receivePurchaseResponse(PurchaseData) {
      this.purchaseTab.purchases = PurchaseData;
    },
    GetProductDetails() {
      let productId = this.$route.params.id;
      this.$store
        .dispatch('product/GetProductById', productId)
        .then((res) => {
          this.Product = res.data;
          this.productDetails = new ProductViewModel(res.data);
          if (this.productDetails.image) {
            this.productDetails.image =
              this.productDetails.image + '?t=' + Date.now();
          }

          this.productDetails.suppliers.forEach((supplier) => {
            this.selectedSuppliers.push(supplier.id);
          });
          this.productUnits = this.productDetails.units;
        })
        .catch((err) => {
          this.messages.push(err.data.title);
        });
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.AddProduct();
      }
    },
    // getStatusColor(status) {
    //   return status == true ? "gray" : "green";
    // },
    startDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    OpenModal() {
      this.productBatch = new ProductBatch();
      this.$refs.batchForm.openModal();
    },
    viewBatch(batch) {
      const id = this.$route.params.id;
      this.$router.push(`${id}/batch/${batch.id}`);
    },
    GetSuppliers(query = '') {
      this.$store
        .dispatch('supplier/GetSupplierSearch', {
          filters: {
            searchText: '',
          },
        })
        .then((res) => {
          this.suppliers = res.map((u, i, arr) => {
            u.index = i + 1;
            return new SupplierListViewModel(u);
          });

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    GetPurchaseTabSuppliers(value) {
      this.$store
        .dispatch('supplier/FetchAllSuppliers', {
          filters: {
            searchText: value,
            roles: [1, 2],
          },
        })
        .then((res) => {
          this.purchaseTab.filter.supplier.items = res.data.data.map(
            (u, i, arr) => {
              u.index = i + 1;
              return new SupplierListViewModel(u);
            },
          );
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    selectSuppliers() {
      (this.selectedSuppliers = []),
        this.Product.suppliers.forEach((supplier) => {
          this.selectedSuppliers.push(
            this.suppliers.find((item) => item.id === supplier),
          );
        });
    },
    refreshBatches($event) {
      this.GetProductDetails();
    },
    editBatch(batch) {
      this.productBatch = _.cloneDeep(batch);
      this.productUnits = batch.unitPriceDetails;
      this.productBatch.isAdd = false;
      this.$refs.batchForm.openModal();
    },
    EditProduct() {
      const credentials = this.productDetails;
      credentials.Id = this.$route.params.id;
      credentials.suppliers = this.selectedSuppliers;
      this.$store
        .dispatch('product/EditProduct', credentials)
        .then((res) => {
          this.succeeed = true;
          this.$toast.success('Product edited successfully');
          this.$router.push('/product');
        })
        .catch((err) => {
          this.messages.push(err.data.title);
          this.$toast.error('Failed to edit product.');
        });
    },
    openImage(image) {
      (this.dialog = true), (this.pic = image);
    },
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
    cancel() {
      this.dialog = false;
    },
  },
  watch: {
    searchPurchaseTabSuppliers(value) {
      if (!value) {
        return;
      }
      this.GetPurchaseTabSuppliers(value);
    },
    searchSuppliers(value) {
      if (!value) {
        return;
      }
      this.GetSuppliers(value);
    },
  },
};
export class PurchaseTabViewModel {
  constructor() {
    this.filter = new PurchaseTabFilters();
    this.headers = [
      { text: 'Invoice Reference', value: 'reference_number' },
      { text: 'Date', value: 'date' },
      { text: 'Ware House', value: 'wareHouse.name' },
      { text: 'Total', value: 'total' },
      { text: 'Balance', value: 'balance' },
      { text: 'Paid', value: 'paid' },
      {
        text: 'Status',
        value: 'is_active',
        align: 'center',
        width: '10%',
      },
      { text: '', value: 'action' },
    ];
    this.purchases = [];
  }
}
export class PurchaseOrderTabViewModel {
  constructor() {
    this.filter = new PurchaseTabFilters();
    this.headers = [
      { text: 'Invoice Reference', value: 'purchaseOrder.reference_number' },
      { text: 'Date', value: 'purchaseOrder.date' },
      { text: 'Ware House', value: 'purchaseOrder.wareHouse.name' },
      {
        text: 'Status',
        value: 'purchaseOrder.status',
        align: 'center',
        width: '10%',
      },
      {
        text: 'Actions',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '10%',
      },
    ];
    this.purchaseOrders = [];
  }
}
export class PurchaseReturnTabViewModel {
  constructor() {
    this.filter = new PurchaseTabFilters();
    this.headers = [
      { text: 'Invoice Reference', value: 'purchaseReturn.reference_number' },
      { text: 'Date', value: 'purchaseReturn.date' },
      { text: 'Amount', value: 'purchaseReturn.amount' },
      { text: 'Return Surcharge', value: 'purchaseReturn.return_surcharge' },
      { text: 'Status', value: 'purchaseReturn.status' },
      {
        text: 'Actions',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '10%',
      },
    ];
  }
}
export class PurchaseTabFilters {
  constructor() {
    this.supplier = new Filter();
    this.searchText = '';
    this.total = '';
    this.dateRangePicker = new DateRangePicker();
  }
}
export class Filter {
  constructor() {
    this.items = [];
    this.selectedItem = 0;
  }
}
export class DateRangePicker {
  constructor() {
    this.range = [];
    this.text = 0;
    this.start = '';
    this.end = '';
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}
.v-expansion-panel-header {
  align-items: center;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  display: flex;
  font-size: 0.9375rem;
  line-height: 1;
  min-height: 30px;
  outline: none;
  padding: 16px 24px;
  position: relative;
  transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.p-100 {
  margin-top: -25px;
  margin-bottom: -18px;
  background-color: white;
}
.productdetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.producttiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.productname {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: left;

  color: #045894;
}

.viewDetails {
  font-weight: bold;
}

.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}

.cards {
  transition: opacity 0.4s ease-in-out;
}

.cards:not(.on-hover) {
  opacity: 0.6;
}

.show-btns {
  color: rgb(228, 53, 53) !important;
}
</style>
